import React, { useState, useEffect } from 'react';
import apiService from '../api/apiService';
import './TablePages.css';

const REGISTRATION_FEE_KEY = 'distributor_registration_fee';
const ORDER_SERVICE_CHARGE_KEY = 'order_service_charge';

const Settings: React.FC = () => {
  const [fee, setFee] = useState('');
  const [serviceCharge, setServiceCharge] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [savingServiceCharge, setSavingServiceCharge] = useState(false);
  const [message, setMessage] = useState('');
  const [serviceChargeMessage, setServiceChargeMessage] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const { data } = await apiService.get('/admin/settings');
        const feeRow = data.find((s: { key: string }) => s.key === REGISTRATION_FEE_KEY);
        const serviceRow = data.find((s: { key: string }) => s.key === ORDER_SERVICE_CHARGE_KEY);
        setFee(feeRow ? feeRow.value : '0');
        setServiceCharge(serviceRow ? serviceRow.value : '0');
      } catch (e) {
        setFee('0');
        setServiceCharge('0');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    setMessage('');
    try {
      await apiService.put(`/admin/settings/${REGISTRATION_FEE_KEY}`, { value: fee });
      setMessage('Saved successfully.');
    } catch (err: any) {
      setMessage(err.response?.data?.detail || 'Failed to save.');
    } finally {
      setSaving(false);
    }
  };

  const handleSaveServiceCharge = async (e: React.FormEvent) => {
    e.preventDefault();
    setSavingServiceCharge(true);
    setServiceChargeMessage('');
    try {
      await apiService.put(`/admin/settings/${ORDER_SERVICE_CHARGE_KEY}`, { value: serviceCharge });
      setServiceChargeMessage('Saved successfully.');
    } catch (err: any) {
      setServiceChargeMessage(err.response?.data?.detail || 'Failed to save.');
    } finally {
      setSavingServiceCharge(false);
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="table-page">
      <div className="section-card">
        <h2>Registration fee</h2>
        <p className="muted">Amount (₹) charged to new distributors. Only admin can set this.</p>
        <form onSubmit={handleSave} className="form-inline">
          <input
            type="number"
            min="0"
            step="0.01"
            value={fee}
            onChange={(e) => setFee(e.target.value)}
            className="input-field"
            placeholder="0"
          />
          <button type="submit" disabled={saving} className="btn-primary">
            {saving ? 'Saving...' : 'Save'}
          </button>
        </form>
        {message && <p className="message">{message}</p>}
      </div>

      <div className="section-card" style={{ marginTop: '24px' }}>
        <h2>Order service charge</h2>
        <p className="muted">
          Amount (₹) added to each order at checkout. Shown to the customer; the full service charge goes to the driver; the remaining order amount goes to the distributor.
        </p>
        <form onSubmit={handleSaveServiceCharge} className="form-inline">
          <input
            type="number"
            min="0"
            step="0.01"
            value={serviceCharge}
            onChange={(e) => setServiceCharge(e.target.value)}
            className="input-field"
            placeholder="0"
          />
          <button type="submit" disabled={savingServiceCharge} className="btn-primary">
            {savingServiceCharge ? 'Saving...' : 'Save'}
          </button>
        </form>
        {serviceChargeMessage && <p className="message">{serviceChargeMessage}</p>}
      </div>
    </div>
  );
};

export default Settings;
